// in src/users.js
import React from "react";
import {
  Filter,
  TextInput,
  required,
  FormDataConsumer,
  ImageField,
  Edit,
  SimpleForm,
  List,
  Datagrid,
  TextField,
  BooleanField,
  BooleanInput,
  EmailField,
  SimpleShowLayout,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  PasswordInput,
  useChoicesContext,
  useGetList,
} from "react-admin";
import { useParams } from "react-router-dom";
import { PermissionsInput } from "./PermissionsInput";
import { PERMISSION_TEMPLATE } from "./utils/permissions.constants";
import { Box, Card, CardContent, Divider, Grid, Typography } from "@mui/material";

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nombre de Empresa" source="first_name" />
    <TextInput label="Razón Social" source="business_name" />
    <BooleanInput label="Usuario Habilitado" source="state"></BooleanInput>
    <BooleanInput label="Proveedor Verificado" source="provider_verified"></BooleanInput>
  </Filter>
);

export const UserList = (props) => (
  <List filters={<UserFilter />} {...props}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <TextField source="first_name" label="Nombre de Empresa" />
      <TextField source="business_name" label="Razón Social" />
      <ImageField source="picture" title="Imagen  no disponible" label="Imagen" />
      <EmailField source="email" />
      <TextField source="phone" label="Teléfono" />
      <TextField source="CI_NIT" label="NIT" />
      <TextField source="role" label="Rol" />
      <BooleanField source="email_verified" label="Email verificado" />
      <BooleanField source="provider_verified" label="Proveedor verificado" />
      <BooleanField source="state" label="Usuario Habilitado" />
      <BooleanField source="providerEnabledForApp" label="Habilitado para app movil" />
    </Datagrid>
  </List>
);

const WithProps = ({ children, ...props }) => children(props);

const BranchSelectInput = ({ source, providerId, ...props }) => {
  const { data, isLoading, error } = useGetList("enterprise/branches", {
    filter: { providerId },
  });

  if (isLoading) return <span>Cargando sucursales...</span>;
  if (error) return <span>Error al cargar sucursales</span>;

  return (
    <SelectInput
      source={source}
      choices={data}
      optionText="name"
      optionValue="_id"
      parse={(value) => data.find((branch) => branch._id === value)}
      format={(value) => value?._id || value}
      {...props}
    />
  );
};

// export const UserEdit = (props, record) => {
//   const params = useParams()
//   return (
//     <Edit {...props}>
//       <WithProps>
//         {({ record, ...props }) => {
//           return (
//             <SimpleForm>
//               {/* 🟦 INFORMACIÓN GENERAL */}
//               <Card sx={{ mb: 3 }}>
//                 <CardContent>
//                   <Typography variant="h6" gutterBottom>
//                     Información General de la Empresa
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                   <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 2 }}>
//                     <TextField source="first_name" label="Nombre de Empresa" />
//                     <TextField source="business_name" label="Razón Social" />
//                     <ImageField source="pictureURL" title="Imagen no disponible" label="Imagen" />
//                     <EmailField source="email" />
//                     <TextField source="phone" label="Teléfono" />
//                     <TextField source="CI_NIT" label="NIT" />
//                     <TextField source="role" label="Rol" />
//                     <BooleanField source="email_verified" label="Email verificado" />
//                   </Box>
//                 </CardContent>
//               </Card>

//               {/* 🟦 ADMINISTRADORES DE SUCURSAL */}
//               <Card sx={{ mb: 3 }}>
//                 <CardContent>
//                   <Typography variant="h6" gutterBottom>
//                     Administradores de Sucursal
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />

//                   <ArrayInput source="branchAdmins" label="">
//                     <SimpleFormIterator
//                       fullWidth
//                       addButtonProps={{ label: "Añadir Administrador" }}
//                       getItemDefaultValue={() => ({
//                         permissions: JSON.parse(JSON.stringify(PERMISSION_TEMPLATE)),
//                       })}
//                     >
//                       {/* Cada admin en una Card */}
//                       <Card variant="outlined" sx={{ mb: 2, p: 2 }}>
//                         <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 2 }}>
//                           <TextInput source="email" label="Correo Electrónico" validate={required()} />
//                           <FormDataConsumer>
//                             {({ scopedFormData }) => {
//                               return scopedFormData && scopedFormData._id ? (
//                                 <TextField label="Contraseña (oculta)" />
//                               ) : (
//                                 <PasswordInput source="password" label="Contraseña" validate={required()} />
//                               );
//                             }}
//                           </FormDataConsumer>
//                           <BranchSelectInput source="branch" providerId={params.id} validate={required()} />
//                         </Box>
//                         <PermissionsInput source="permissions" />
//                       </Card>
//                     </SimpleFormIterator>
//                   </ArrayInput>
//                 </CardContent>
//               </Card>

//               {/* 🟦 CONFIGURACIONES */}
//               <Card>
//                 <CardContent>
//                   <Typography variant="h6" gutterBottom>
//                     Configuraciones Adicionales
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                   <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//                     <BooleanInput source="provider_verified" label="Proveedor verificado" />
//                     <BooleanInput source="state" label="Usuario Habilitado" />
//                     <BooleanInput source="providerEnabledForApp" label="Habilitado para app móvil" />
//                   </Box>
//                 </CardContent>
//               </Card>
//             </SimpleForm>
//           );
//         }}
//       </WithProps>
//     </Edit>
//   );
// };
export const UserEdit = (props) => {
  // const notify = useNotify();
  const params = useParams();
  return (
    <Edit {...props}>
      <WithProps>
        {({ record, ...props }) => {
          return (
            <SimpleForm>
              <SimpleShowLayout>
                <TextField source="first_name" label="Nombre de Empresa" />
                <TextField source="business_name" label="Razón Social" />
                <ImageField source="pictureURL" title="Imagen no disponible" label="Imagen" />
                <EmailField source="email" />
                <TextField source="phone" label="Teléfono" />
                <TextField source="CI_NIT" label="NIT" />
                <TextField source="role" label="Rol" />
                <BooleanField source="email_verified" label="Email verificado" />
              </SimpleShowLayout>
              <ArrayInput source="branchAdmins" label="Administradores de Sucursal">
                <SimpleFormIterator
                  /* cada nuevo item saldrá con esta estructura */
                  addButtonProps={{
                    label: "Añadir Administrador",
                  }}
                  fullWidth
                  // tiny helper para pre‑llenar nuevo registro:
                  getItemDefaultValue={() => ({
                    permissions: JSON.parse(JSON.stringify(PERMISSION_TEMPLATE)),
                  })}
                >
                  <TextInput source="email" label="Correo Electrónico" sx={{ marginTop: 2.5 }} validate={required()} />
                  <FormDataConsumer>
                    {({ getSource, scopedFormData }) => {
                      const passwordSource = getSource("password");
                      return scopedFormData && scopedFormData._id ? (
                        <TextField label="Contraseña (oculta)" />
                      ) : (
                        <PasswordInput source={passwordSource} label="Contraseña" validate={required()} />
                      );
                    }}
                  </FormDataConsumer>
                  <BranchSelectInput source="branch" providerId={params.id} validate={required()} />
                </SimpleFormIterator>
              </ArrayInput>
              <BooleanInput source="provider_verified" label="Proveedor verificado" />
              <BooleanInput source="state" label="Usuario Habilitado" />
              <BooleanInput source="providerEnabledForApp" label="Habilitado para app movil" />
              {/* <FormDataConsumer>
              </FormDataConsumer> */}
            </SimpleForm>
          );
        }}
      </WithProps>
    </Edit>
  );
};

{
  /* <ArrayInput source="branchAdmins">
  <SimpleFormIterator
    addButtonProps={{ label: "Añadir administrador" }}
    getItemDefaultValue={() => ({
      permissions: JSON.parse(JSON.stringify(PERMISSION_TEMPLATE)),
    })}
  >
    <Box sx={{ border: "1px solid #e0e0e0", p: 2, borderRadius: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <TextInput
            source="email"
            label="Correo Electrónico"
            fullWidth
            validate={[required()]}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <FormDataConsumer>
            {({ scopedFormData }) =>{
              console.log("scopedFormData", scopedFormData)
              return (
                scopedFormData && scopedFormData._id ? (
                  <TextField label="Contraseña (oculta)" fullWidth />
                ) : (
                  <PasswordInput
                    source="password"          // ← ya no usamos getSource
                    label="Contraseña"
                    validate={required()}
                    fullWidth
                  />
                )
              )
            }}
          </FormDataConsumer>
        </Grid>

        <Grid item xs={12} md={4}>
          <BranchSelectInput
            source="branch"
            label="Sucursal"
            providerId={params.id}
            fullWidth
            validate={[required()]}
          />
        </Grid>

        <Grid item xs={12}>
          <PermissionsInput source="permissions" />
        </Grid>
      </Grid>
    </Box>
  </SimpleFormIterator>
</ArrayInput> */
}
// <Edit {...props}>
//   <WithProps>
//     {({ record, ...props }) => {
//       return (
//         <SimpleForm>
//           <SimpleShowLayout>
//             <TextField source="first_name" label="Nombre de Empresa" />
//             <TextField source="business_name" label="Razón Social" />
//             <ImageField source="pictureURL" title="Imagen no disponible" label="Imagen" />
//             <EmailField source="email" />
//             <TextField source="phone" label="Teléfono" />
//             <TextField source="CI_NIT" label="NIT" />
//             <TextField source="role" label="Rol" />
//             <BooleanField source="email_verified" label="Email verificado" />
//           </SimpleShowLayout>
//           <ArrayInput source="branchAdmins" label="Administradores de Sucursal">
//             <SimpleFormIterator
//               /* cada nuevo item saldrá con esta estructura */
//               addButtonProps={{
//                 label: "Añadir Administrador",
//               }}
//               fullWidth
//               // tiny helper para pre‑llenar nuevo registro:
//               getItemDefaultValue={() => ({
//                 permissions: JSON.parse(JSON.stringify(PERMISSION_TEMPLATE)),
//               })}
//             >
//               <TextInput source="email" label="Correo Electrónico" sx={{marginTop: 2.5}} validate={required()} />
//               <FormDataConsumer>
//                 {({ getSource, scopedFormData }) => {
//                   const passwordSource = getSource("password");
//                   return scopedFormData && scopedFormData._id ? (
//                     <TextField label="Contraseña (oculta)" />
//                   ) : (
//                     <PasswordInput source={passwordSource} label="Contraseña" validate={required()} />
//                   );
//                 }}
//               </FormDataConsumer>
//               <BranchSelectInput source="branch" providerId={params.id} validate={required()} />
//               <PermissionsInput source="permissions" />
//             </SimpleFormIterator>
//           </ArrayInput>
//           <BooleanInput source="provider_verified" label="Proveedor verificado" />
//           <BooleanInput source="state" label="Usuario Habilitado" />
//           <BooleanInput source="providerEnabledForApp" label="Habilitado para app movil" />
//           {/* <FormDataConsumer>
//           </FormDataConsumer> */}
//         </SimpleForm>
//       );
//     }}
//   </WithProps>
// </Edit>
